import type { ComponentProps } from "react";
import { tv, type VariantProps } from "tailwind-variants";

const cardVariants = tv({
  base: "rounded-card border border-line bg-surface text-content shadow-card",
  variants: {
    elevation: {
      flat: "shadow-none",
      raised: "shadow-raised",
    },
  },
});

export type CardProps = ComponentProps<"article"> & VariantProps<typeof cardVariants>;

export const Card = ({ className, elevation, ...props }: CardProps) => {
  return <article className={cardVariants({ className, elevation })} {...props} />;
};
